import React, { useState, useEffect } from "react";
import "../../css/style-new.css";
import "../../css/developer1.css";
// import "../../css/bootstrap.min.css";
import "../../css/font.css";
import Logo from "../../images/logo.jpg";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { loginurl,validateotp,senddata, GOOGLECLIENTID } from '../../apis/urls';
import { relativeTimeRounding } from "moment";
import { $ } from "react-jquery-plugin";
import { Notification, Placeholder } from "rsuite";
import GoogleLoginButton from "../../common-components/GoogleLoginButton";
import { GoogleOAuthProvider } from '@react-oauth/google';
import { jwtDecode } from "jwt-decode";

const AdminLogin = () => {

  const userData = JSON.parse(localStorage.getItem('userData') || '[]');

  // Get the current date and time
  const currentDate = new Date();
  
  // Check and remove expired entries
  userData.forEach((user, index) => {
    const expirationDate = new Date(user.expirationDate);
    if (expirationDate <= currentDate) {
      // Remove the expired entry from the array
      userData.splice(index, 1);
    }
  });
  localStorage.setItem('userData', JSON.stringify(userData));



  const [uname, setUname] = useState('');
  const [pword, setPword] = useState('');
  const [unameerror, setUnameerror] = useState('');
  const [pworderror, setPworderror] = useState('');
  const [incorrect, setIncorrect] = useState('');
  const [login, setLogin] = useState(false);
  const [adminPassowrd, setAdminPassword] = useState(true);

  const [showOtpField, setShowOtpField] = useState(false);
  const [otp, setOtp] = useState(false);
  const [otperror, setOtperror] = useState('');
  const [otpSubmitted, setOtpSubmitted] = useState(false);


  let navigate = useNavigate();
const [otpMessage, setOtpMessage] = useState('');

  // useEffect to set and clear the OTP message
  useEffect(() => {
    // Set the initial OTP message
    if (showOtpField) {
      setOtpMessage("Kindly enter the OTP sent to the email associated with the username");
    }
  }, [showOtpField]);

  useEffect(() => {
    // Clear the OTP message when the user starts typing
    setOtpMessage('');
  }, [otp]);

  useEffect(() => {
   
    

    $('body').removeClass('sidebar-collapsed sidebar-active').addClass('');


    let storevariable = localStorage.getItem('token');
    let username = localStorage.getItem('username');
    let userid = localStorage.getItem('userid');
    let userrole = localStorage.getItem('userrole');
    let schools = localStorage.getItem('schoolid')
    let associations = localStorage.getItem('association')
    let official = localStorage.getItem('official');
    let coachid = localStorage.getItem('coachid');
    console.log('stvar', storevariable)
    //if( storevariable != 'undefined' || storevariable != null )
    if (storevariable) {

      storeCollector(storevariable, username, userid, userrole, schools, associations, official, coachid);
      //localStorage.clear();
    }


  }, []

  );


  const storeCollector = (a_token, username, uid, urole, school, association, officials) => {

    console.log("ifffff", 0)
    localStorage.setItem('token', a_token)
    localStorage.setItem('username', username)
    localStorage.setItem('userid', uid)
    localStorage.setItem('userrole', urole)
    localStorage.setItem('schoolid', school)
    localStorage.setItem('association', association)
    localStorage.setItem('official', officials)
    localStorage.setItem('coachid', 0)

    let store = localStorage.getItem('token');
    let role = localStorage.getItem('userrole');
    let usid = localStorage.getItem('userid');
    let schoolid = localStorage.getItem('schoolid')
    let associationid = localStorage.getItem('association');
    let official_id = localStorage.getItem('official')
    let coachId = localStorage.getItem('coachid')
    //let ustore = localStorage.getItem('username');
    console.log('auth_token', official_id)
    if (store != 'undefined' || store != null) {


      if (role === 'HO_SCHOOL') {
        // let path = '/school_profile/' + schoolid;
        // navigate(path)
        //window.location.reload()
          Logout();
      } else if (role === 'ATHLETIC_MANAGER') {

        //console.log('schoolid',schoolid)
        // let path = '/school_profile/' + schoolid;
        // navigate(path)
        //window.location.reload()
          Logout();

      } else if (role === 'ASSOCIATION_USER') {
        // let path = '/associationview/'+ associationid;        
        // navigate(path)
        // window.location.reload()
        // alert("Go to Association Login Page")
          Logout();

      } else if (role === 'OFFICIALS_USER') {
        // let path = '/select_rule/' + coachId;
        // navigate(path)
        // window.location.reload()
          Logout();
      }
      else {

        // let path = '/dashboard';        
        // navigate(path)
        // window.location.reload()
        // const localstorageotpdata =  localStorage.getItem('otp');
        // const user_name = localStorage.getItem('user_name');
        // let username = localStorage.getItem('username');
       
        // if(localstorageotpdata && user_name === username)
        //   {
        //      let path = '/dashboard';        
        //      navigate(path)
        //      setShowOtpField(false);
        //   }
        //   else
        //   {
        //     setShowOtpField(true);
        //   }
      }
    }

  }

  const Logout =()=>{
    localStorage.removeItem('token');
    localStorage.removeItem('username');
    localStorage.removeItem('userid');
    localStorage.removeItem('userrole');
    localStorage.removeItem('test_attempted')

  }

  const onFormSubmit = (e) => {
    e.preventDefault()
    
    let error = 0;
    
    if (uname === '' && pword === '') {
      setUnameerror('Enter the username')

      setPworderror('Enter the Password')

      error = 1;
    } else if (uname !== '' && pword === '') {
      setUnameerror('')

      setPworderror('Enter the Password')
      error = 1;

    } else if (uname === '' && pword !== '') {
      setUnameerror('Enter the username')

      setPworderror('')
      error = 1;

    }
    else if (uname === '') {
      setUnameerror('Enter the username')
      error = 1;
    } else if (pword === '') {
      setPworderror('Enter the password')
      error = 1;
    }
    else {

      setUnameerror('')

      setPworderror('')
    }

   

   
   
    if (error === 0) {


      loginFunction(uname, pword, false, '');

    //   const instance = axios.create({

    //     baseURL: loginurl,

    //     timeout: 1000000,

    //   });

    //  const localstorageotp =  localStorage.getItem('otp');
    //  const dat =  localStorage.getItem('userData')

    //   const data = {
    //     username: uname,
    //     password: pword,
    //     otp : localstorageotp?true:false,
    //     dat : dat
    //   }
  
    //   instance.post('', data).then((response) => {

    //     if(response.data.data.role !== 'SUPERADMIN'){
    //       setAdminPassword('Invalid username or password')
    //     }else{
    //       console.log('coachdata', response.data.data)
    //       storeCollector(response.data.data.accessToken, response.data.data.username, response.data.data.id, response.data.data.role, response.data.data.school, response.data.data.association, response.data.data.officials, response.data.data.coachid);
          
    //       const localstorageotpdata =  localStorage.getItem('otp');
         
    //       let username = localStorage.getItem('username');

    //       const use = JSON.parse(localStorage.getItem('userData') || '[]');
          
       
    //       // if(localstorageotpdata && user_name === username)
    //       // {
    //       //    let path = '/dashboard';        
    //       //    navigate(path)
    //       //    setShowOtpField(false);
    //       // }
    //       // else
    //       // {
    //       //   setShowOtpField(true);
    //       // }

    //       const userExistsInArray = use.some(
    //         (userData) => userData.username === username && userData.otp === true
    //       );
        
    //       if (userExistsInArray) {
    //         let path = '/dashboard';
    //         navigate(path);
    //         setShowOtpField(false);
    //       } 
    //       else if(!userExistsInArray) {
    //         setShowOtpField(true);
            
    //       }else{
    //         setShowOtpField(true);
            
    //       }
          
    //     }
    //   }).catch((error) => {
    //     //console.log('error',error.response.data.message)
    //     setIncorrect(error.response.data.message)

    //   });




    }

  }

 
  const [datanew, setDatanew] = useState({});

  
  const handleOTPValidation = () => {
    
    if (!otp) {
      setOtperror('Enter the OTP');
      return;
    }
    else if (uname === '') {
      setUnameerror('Enter the username')
      
    } else if (pword === '') {
      setPworderror('Enter the password')
      
    }
    
    const instance = axios.create({
      baseURL: validateotp, 
      timeout: 1000000,
    });

    const data = {
      otp: otp,
      username: uname,
      password: pword,
    };


    



    instance.post('', data)
    .then((response) => {
      if (response.data.message === "OTP validation successful") {
        
        // const itemToStore = {
        //   data: otp,
        //   expirationDate: new Date()
        // };
        
        // itemToStore.expirationDate.setDate(itemToStore.expirationDate.getDate() + 60);
        
        // localStorage.setItem('otp', JSON.stringify(itemToStore));

        const itemToStore = {
          data: true,
          expirationDate: new Date()
        };
        itemToStore.expirationDate.setDate(itemToStore.expirationDate.getDate() + 60);
        localStorage.setItem('otp', JSON.stringify(itemToStore));
        

        const existingUserData = JSON.parse(localStorage.getItem('userData')) || [];
        const newUser = {
          username: response.data.data.username,
          otp: true,
          expirationDate: new Date(),
        };

        newUser.expirationDate.setDate(newUser.expirationDate.getDate() + 60);
        //newUser.expirationDate.setMinutes(newUser.expirationDate.getMinutes() + 2);
        existingUserData.push(newUser);
        localStorage.setItem('userData', JSON.stringify(existingUserData));

         //navigate('/dashboard');
        storeCollector(response.data.data.accessToken, response.data.data.username, response.data.data.id, response.data.data.role, response.data.data.school, response.data.data.association, response.data.data.officials, response.data.data.coachid);
        navigate('/dashboard');
      } else if (response.data.message === "OTP validation failed") {
        setOtperror('Invalid OTP');
      } else {
        
        setOtperror('Unknown error occurred');
      }
    })
    .catch((error) => {
     
      setOtperror('failed to validate otp');
    });
  };
  const handleLoginSuccess = (response) => {
    console.log('Login Success:', response);

    const decodedToken = jwtDecode(response.credential);
    const email = decodedToken.email;
    loginFunction(email, pword, true, response.credential);
    console.log('decodedToken', email)
  };

  const handleLoginFailure = (response) => {
    console.log('Login Failed:', response);
    // Handle login failure
  };

  const loginFunction = async (uname, pword, googlelogin, authToken) => {
    const instance = axios.create({
      baseURL: loginurl,
      timeout: 1000000,
    });
  
    const localstorageotp = localStorage.getItem('otp');
    const dat = localStorage.getItem('userData');
  
    const data = {
      username: uname,
      password: pword,
      otp: localstorageotp ? true : false,
      dat: dat,
      authToken: authToken,
      googlelogin: googlelogin,
    };
  
    try {
      const response = await instance.post('', data);
  
      if (response.data.data.role !== 'SUPERADMIN') {
        setAdminPassword('Invalid username or password');
      } else {
        console.log('coachdata', response.data.data);
        storeCollector(
          response.data.data.accessToken,
          response.data.data.username,
          response.data.data.id,
          response.data.data.role,
          response.data.data.school,
          response.data.data.association,
          response.data.data.officials,
          response.data.data.coachid
        );
  
        const localstorageotpdata = localStorage.getItem('otp');
        let username = localStorage.getItem('username');
  
        const use = JSON.parse(localStorage.getItem('userData') || '[]');
  
        const userExistsInArray = use.some(
          (userData) => userData.username === username && userData.otp === true
        );
  
        if (userExistsInArray || googlelogin) {
          let path = '/dashboard';
          navigate(path);
          setShowOtpField(false);
        } else {
          setIncorrect("");
          setShowOtpField(true);
        }
      }
    } catch (error) {
      setIncorrect(error.response.data.message);
    }
  };

  return (

    <div className="wrapper loginp">
      <aside className="left-side login-leftside side-off-canvas">
        <div className="logo-wrpr">
          <img src={Logo} width="" height="" alt="" />
        </div>


      </aside>

      <aside className="right-side login-rightside">




      <div className="content-area no-header">

      <div class="google-login-box">
					<h3 style={{color:'white'}}>Already have an account? Please Login</h3>
					<span style={{display:'flex'}} class="google-badge-cntnr">
          
            <GoogleOAuthProvider clientId={GOOGLECLIENTID}>
                <div >
                  <GoogleLoginButton 
                    onSuccess={handleLoginSuccess}
                    onFailure={handleLoginFailure}
                  />
                </div>
              </GoogleOAuthProvider>
               <span style={{marginLeft:'8px', marginTop:'6px'}}>or</span>
          </span>
				</div>

          <form onSubmit={(e) => { onFormSubmit(e) }} className="needs-validation" noValidate>
            <div className="login-title text-center text-white">Admin Login</div>
            <div className="form-group">
              <label htmlFor="uname">Username:</label>
              <input type="text" className="form-control" value={uname} onChange={e => setUname(e.target.value)} id="uname" placeholder="Enter username" name="uname" required></input>
              <div className="valid-feedback">Valid.</div>
              <div className="errors" style={{ color: "#FF9800", fontSize: "12.8px",fontWeight:500 }}>{unameerror}</div>
            </div>
            <div className="form-group">
              <label htmlFor="pwd">Password:</label>
              <input type="password" className="form-control" value={pword} onChange={e => setPword(e.target.value)} id="pwd" placeholder="Enter password" name="pswd" required></input>
              <div className="valid-feedback">Valid.</div>
              <div className="errors" style={{ color: "#FF9800", fontSize: "12.8px",fontWeight:500 }}>{pworderror}</div>
              <div className="errors" style={{ color: "#FF9800", fontSize: "12.8px",fontWeight:500 }}>{incorrect}</div>
              <div className="errors" style={{ color: "#FF9800", fontSize: "12.8px",fontWeight:500 }}>{adminPassowrd}</div>

              
            </div>

            {/* Conditional rendering for OTP input field */}
            {showOtpField && (
              <div className="form-group">
                <label htmlFor="otp">Enter OTP:</label>
                <input
                  type="text"
                  className="form-control"
                  onChange={(e) => setOtp(e.target.value)}
                  id="otp"
                 
                  placeholder="Enter OTP"
                  name="otp"
                  required
                />
                <div className="valid-feedback">Valid.</div>
                <div className="errors" style={{ color: "#FF9800", fontSize: "12.8px",fontWeight:500 }}>{otperror}</div>
                <div className="message" style={{ color: "white", fontSize: "12.8px" }}>{otpMessage}</div>
              </div>
            )}

            <div className="forgot-pass-and-login-btn ">

              <Link to="/forgot_password" className="forgot">Forgot Password?</Link>


              {showOtpField ? (
                
                <button type="button" onClick={handleOTPValidation} className="btn btn-primary">
                  Login
                </button>
              ) : (
                <button type="submit" className="btn btn-primary">
                Login <i className="icon-keyboard_arrow_right"></i>
                </button>
              )}

              
            </div>

          </form>

        </div>

      </aside>

    </div>
  );



};

export default AdminLogin;